<template>
  <div class="invite-users">
    <div class="invite-users-header">
      <h3>{{ noValuesLabel }}</h3>
    </div>

    <div class="invite-users-content">
      <div class="options">
        <div
          v-for="(option, idx) in options"
          :key="idx"
          class="option"
        >
          <input
            type="radio"
            :id="option.input"
            :value="option.input"
            v-model="picked"
            @change="activateOption"
          />
          <img :src="getImage(option.image)" :alt="option.name" />
          <span>{{ option.name }}</span>
          <span v-if="option.subtitle" id="subtitle">{{ option.subtitle }}</span>
        </div>
      </div>
    </div>
    <div class="invite-users-footer">
      <primary-button
        ref="continue"
        @click.native="onClickContinue"
        disabled
      >
        {{$t('common.continue')}}
      </primary-button>
    </div>
  </div>
</template>

<script>
  import PrimaryButton from '@/components/common/buttons/PrimaryButton'
  import { handleSubmitButtonState } from '../../helpers/formValidationHelper'

  export default {
    components: {
      PrimaryButton,
    },
    props: {
      noValuesLabel: {
        type: String,
        default: ''
      },
    },
    data() {
      return {
        picked: '',
        options: [
          {
            input: 'import-users',
            image: 'import-emails.svg',
            name: this.$t('organizations.invite_users.import_users'),
          },
          {
            input: 'import-users-classes',
            image: 'import-emails.svg',
            name: this.$t('organizations.invite_users.import_users_classes'),
          },
          {
            input: 'email-invite',
            image: 'copy-paste-emails.svg',
            name: this.$t('organizations.invite_users.mail_invite')
          },
        ]
      }
    },
    methods: {
      hiddenOption(option) {
        return option.isVisible !== undefined ? option.isVisible : true
      },
      getImage(image) {
        return require(`@/assets/images/${image}`)
      },
      activateOption(e) {
        const elementClasses = e.target.parentElement.classList
        if (!elementClasses.contains('active')) {
          const options = document.getElementsByClassName('option')
          for(let option of options) {
            option.classList.remove('active')
          }
          elementClasses.add('active')

          return handleSubmitButtonState(this.$refs.continue.$el, true)
        }
      },
      onClickContinue(){
        this.$emit('toggle-organization-nav', false)
        this.$emit('invite-users', this.picked)
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import '../../scss/_colors.scss';

  .options {
    display: grid;
    grid-template-columns: 202px 202px 202px 202px;
    grid-column-gap: 32px;
    margin-top: 4px;

    .option {
      border: 2px solid transparent;
      background: white;
      box-shadow: 0px 4px 11px rgba(37, 27, 94, 0.11);
      border-radius: 16px;
      padding: 40px 20px;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;

      &.hidden {
        display: none;
      }

      img {
        margin-bottom: 31px;
        width: 122px;
        height: 122px;
      }

      span {
        font-family: 'SF Pro Display';
        font-weight: normal;
        font-size: 16px;
        color: $black;
        mix-blend-mode: normal;
        text-align: center;

        &#subtitle {
          color: $dark-blue-2;
          text-transform: none;
        }
      }

      input {
        cursor: pointer;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        z-index: 111;
      }

      &.active {
        background: #F5FCFF;
        box-shadow: 0px 8px 18px rgba(64, 156, 255, 0.26);
        span {
          color: $purple;
          font-weight: 500;
        }
      }
    }
  }

  .invite-users-header {
    padding-bottom: 38px;

    h3 {
      font-weight: 400;
      color: $black;
      opacity: 0.65;
      text-transform: none;
      margin: 0;
    }
  }

  .invite-users-footer {
    padding-top: 50px;
  }
</style>
